/**
 * Model to hold a single email recipient.
 */
export class EmailRecipient {
    public id: string = null;
    public name: string = null;
    public email: string = null;
    public isCc: boolean = false;
    public isBcc: boolean = false;

    constructor(email?: string, isCc?: boolean, isBcc?: boolean) {
        this.email = email || this.email;
        this.isCc = isCc || this.isCc;
        this.isBcc = isBcc || this.isBcc;
    }

    public clone(): EmailRecipient {
        const clone: EmailRecipient = new EmailRecipient();
        clone.id = this.id;
        clone.name = this.name;
        clone.email = this.email;
        clone.isCc = this.isCc;
        clone.isBcc = this.isBcc;

        return clone;
    }

    /**
     * Serialize from a json api format
     */
    public serialize(): string {
        const json: any = {};
        json.data = {};
        json.data.type = 'emailMessage';
        json.data.id = this.id;
        json.data.attributes = {};
        json.data.attributes.name = this.name;
        json.data.attributes.email = this.email;
        json.data.attributes.isCc = this.isCc;
        json.data.attributes.isBcc = this.isBcc;
        return JSON.stringify(json);
    }

    /**
     * Deserialize to a json api format
     */
    public deserialize(json: Object): EmailRecipient {
        const data: Object = json['data'] || json;
        const attrs: Object = data['attributes'];

        this.id = data['id'];
        this.name = attrs['name'];
        this.email = attrs['email'];
        this.isCc = attrs['isCc'];
        this.isBcc = attrs['isBcc'];

        return this;
    }
}
